import { BRAND } from "constants/brand";
import { useEffect, useRef, useState } from "react";
import { Form } from "react-bootstrap";

import { Ring } from "@uiball/loaders";
import useProduct from "hooks/useProducts";
import { useGetVendorsDropdown } from "hooks/useVendors";
import useCategories from "hooks/useCateogries";
import Switch from "@mui/material/Switch";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import OptionGroup from "./OptionGroup/OptionGroup";
import { useNavigate, useParams } from "react-router-dom";
import imageCompression from "browser-image-compression";
import useOptions from "hooks/useOptions";
import { useSelector } from "react-redux";
import Select from "components/Ui/SelectField/SelectField";
import { fieldOf } from "utils/formField";
import { readApiError } from "utils/apiError";

const EditProduct = (props) => {
    const {
        loading,
        error,
        editProduct,
        fetchProductBYId,
        createGroup,
        deleteGroup,
        deleteOption,
    } = useProduct();
    const [productOptions, setProductOptions] = useState([]);
    const [isOffer, setIsOffer] = useState(false);
    const [available, setAvailable] = useState(false);
    const [featured, setFeatured] = useState(false);
    const [show_price, setShowPrice] = useState(false);
    const [isNewCart, setIsNewCart] = useState(false);
    const [product, setProduct] = useState(null);
    const { vendors } = useGetVendorsDropdown();
    const { categories } = useCategories();
    const form = useRef();
    const { id } = useParams();
    const [image, setImage] = useState(null);
    const navigate = useNavigate();
    const { options, fetchOptions } = useOptions();
    const adminInfo = useSelector((state) => state.auth.userData);
    const [vendor, setvendor] = useState(null);
    const [category, setCategory] = useState(null);

    useEffect(() => {
        fetchOptions({});
    }, []);

    useEffect(() => {
        const fetchProduct = async () => {
            try {
                const response = await fetchProductBYId(id);
                if (response) {
                    setvendor(response.vendorId);
                    setCategory(response.categoryId);
                    setFeatured(response.featured);
                    setAvailable(response.available);
                    setShowPrice(response.show_price);
                    setIsNewCart(response.isNewCart);
                    setProductOptions(response.options_groups);
                    setIsOffer(response.isOffer);
                }
                setProduct(response);
            } catch (error) {
                console.log(error);
            }
        };
        fetchProduct();
    }, [id]);

    const deleteGroupHandler = async (id) => {
        const checkExist = product.options_groups.findIndex((group) => +group.id === +id);
        if (checkExist > -1) {
            await deleteGroup(id);
        }
        const newGroups = productOptions.filter((group) => +group.id !== +id);

        setProductOptions(newGroups);
    };

    const getOptionData = (data) => {
        const options = [...productOptions];

        const index = options.findIndex((option) => +option.id === +data.id);

        if (index > -1) {
            options[index] = data;
        } else {
            options.push(data);
        }
        setProductOptions(options);
    };

    const handleImageChange = async (event) => {
        const file = event.target.files[0];
        if (file) {
            try {
                const compressedFile = await imageCompression(file, {
                    maxWidthOrHeight: 1024, // Resize to max 1024px width/height
                    maxSizeMB: 0.6, // Limit to 1MB
                });
                const compressedFileObj = new File([compressedFile], file.name, {
                    type: file.type,
                });

                setImage(compressedFileObj); // Set resized image preview
            } catch (error) {
                console.error("Error resizing image:", error);
            }
        }
    };

    const submitHandler = async (e) => {
        e.preventDefault();
        const productData = new FormData();

        if (fieldOf(form.current, "image").files[0]) {
            productData.append("image", image, fieldOf(form.current, "image").files[0].name);
        }
        productData.append("id", product.id);
        productData.append("title", fieldOf(form.current, "title").value);
        productData.append("vendorId", vendor);
        productData.append("categoryId", category);
        productData.append("price", fieldOf(form.current, "price").value);
        productData.append("description", fieldOf(form.current, "description").value);
        productData.append("order", fieldOf(form.current, "order").value);
        productData.append("offerPrice", fieldOf(form.current, "offerPrice").value || 0);
        productData.append("isOffer", fieldOf(form.current, "isOffer").checked);
        productData.append("featured", fieldOf(form.current, "featured").checked);
        productData.append("available", fieldOf(form.current, "available").checked);
        productData.append("show_price", fieldOf(form.current, "show_price").checked);
        productData.append("isNewCart", fieldOf(form.current, "isNewCart").checked);

        try {
            const response = await editProduct(productData);
            const groupFormData = new FormData();
            groupFormData.append("products", JSON.stringify([response.product?.id]));
            groupFormData.append("groupsData", JSON.stringify(productOptions));

            productOptions.forEach((group, groupIndex) => {
                group.options.forEach((option, optionIndex) => {
                    // Example: if you have a File object for this option
                    const file = option.image; // 👈 must come from <input type="file" /> or similar

                    if (file) {
                        // The key includes indexes so the backend knows which option this image belongs to
                        groupFormData.append(
                            `groups[${groupIndex}][options][${optionIndex}][image]`,
                            file,
                        );
                    }
                });
            });

            const groupResponse = await createGroup(groupFormData);
            // The hook RETURNS a failed call. The product is saved, and its
            // groups are not: say so, and stay on the page to repair them.
            const groupError = readApiError(groupResponse, "تعذر حفظ الخيارات");
            if (response.product && groupError) {
                props.showMessage("error", "تم حفظ المنتج، ولم تُحفظ الخيارات", groupError);
                return;
            }
            if (response.product) {
                props.showMessage("success", "تم التعديل", "تم تعديل المنتج بنجاح");
                navigate(-1);
            } else {
                props.showMessage("error", "هناك خطأ", response || "حدث خطأ غير متوقع");
            }
        } catch (err) {
            console.error("Error adding vendor:", err);
            props.showMessage("error", "هناك خطأ", readApiError(err, "حدث خطأ غير متوقع"));
        }
    };
    const vendorOptions = vendors?.map((v) => ({
        value: v.id,
        label: v.name,
    }));

    const categorieOptions = categories?.map((v) => ({
        value: v.id,
        label: v.name,
    }));
    return (
        <div className={`add-product`}>
            {loading ? (
                <div className="loading-spinner center">
                    <Ring size={40} lineWeight={5} speed={2} color={BRAND} />
                </div>
            ) : null}
            <h3 className="text-center" style={{ marginBottom: "20px" }}>
                تعديل منتج
            </h3>

            <form ref={form} className="row row-cols-1" onSubmit={submitHandler}>
                <div className="col-md-4 col-lg-4">
                    <Form.Group className="mb-3" controlId="image">
                        <Form.Label>صوره المنتج</Form.Label>
                        <Form.Control
                            name="image"
                            type="file"
                            onChange={handleImageChange}
                            accept=".png,.jpg,.jpeg,.svg,.webp"
                        />
                    </Form.Group>
                </div>
                <div className="col-md-4 col-lg-4">
                    <Form.Group className="mb-3" controlId="name">
                        <Form.Label>
                            اسم المنتج<span style={{ color: "red" }}>*</span>
                        </Form.Label>
                        <Form.Control
                            name="title"
                            type="text"
                            defaultValue={product?.title}
                            placeholder="اسم المنتج"
                            required
                        />
                    </Form.Group>
                </div>
                <div className="col-md-4 col-lg-4">
                    <Form.Group className="mb-3" controlId="vendor">
                        <Form.Label>
                            المطعم<span style={{ color: "red" }}>*</span>
                        </Form.Label>
                        <Select
                            options={vendorOptions}
                            placeholder="اختر المطعم"
                            onChange={(selected) => {
                                setvendor(selected.value);
                            }}
                            value={vendorOptions.find((v) => v.value === +vendor)}
                            isSearchable
                        />
                    </Form.Group>
                </div>
                <div className="col-md-4 col-lg-4">
                    <Form.Group className="mb-3" controlId="category">
                        <Form.Label>
                            القسم<span style={{ color: "red" }}>*</span>
                        </Form.Label>
                        <Select
                            options={categorieOptions}
                            placeholder="اختر القسم"
                            value={categorieOptions.find((v) => v.value === +category)}
                            onChange={(selected) => {
                                setCategory(selected.value);
                            }}
                            isSearchable
                        />
                    </Form.Group>
                </div>
                <div className="col-md-4 col-lg-4">
                    <Form.Group className="mb-3" controlId="price">
                        <Form.Label>
                            السعر (₪)<span style={{ color: "red" }}>*</span>
                        </Form.Label>
                        <Form.Control
                            name="price"
                            type="number"
                            defaultValue={product?.price}
                            min={0}
                            placeholder="السعر"
                            required
                        />
                    </Form.Group>
                </div>
                <div className="col-md-4 col-lg-4">
                    <Form.Group className="mb-3" controlId="desc">
                        <Form.Label>الوصف</Form.Label>
                        <Form.Control
                            name="description"
                            defaultValue={product?.description}
                            type="text"
                            placeholder="الوصف"
                        />
                    </Form.Group>
                </div>
                <div className="col-md-4 col-lg-4">
                    <Form.Group className="mb-3" controlId=" offerPrice">
                        <Form.Label>ترتيب الظهور</Form.Label>
                        <Form.Control
                            name="order"
                            type="number"
                            defaultValue={product?.order}
                            min={1}
                            placeholder=""
                        />
                    </Form.Group>
                </div>
                <div className="col-md-4 col-lg-4">
                    <Form.Group className="mb-3" controlId=" offerPrice">
                        <Form.Label>السعر بعد الخصم (₪)</Form.Label>
                        <Form.Control
                            name="offerPrice"
                            type="number"
                            defaultValue={product?.offerPrice}
                            min={0}
                            placeholder="السعر بعد الخصم"
                        />
                    </Form.Group>
                </div>
                <div className="col-md-4 col-lg-4">
                    <FormGroup>
                        <FormControlLabel
                            checked={isOffer}
                            control={
                                <Switch
                                    name="isOffer"
                                    color="warning"
                                    onChange={(e) => {
                                        setIsOffer((pre) => (pre = !pre));
                                    }}
                                />
                            }
                            label="تفعيل العرض"
                        />
                    </FormGroup>
                </div>
                <div className="col-md-4 col-lg-4">
                    <FormGroup>
                        <FormControlLabel
                            control={
                                <Switch
                                    name="featured"
                                    checked={featured}
                                    color="warning"
                                    onChange={(e) => {
                                        setFeatured((pre) => (pre = !pre));
                                    }}
                                />
                            }
                            label="هل هذا المنتج مميز"
                        />
                    </FormGroup>
                </div>
                <div className="col-md-4 col-lg-4">
                    <FormGroup>
                        <FormControlLabel
                            control={
                                <Switch
                                    name="available"
                                    checked={available}
                                    color="warning"
                                    onChange={(e) => {
                                        setAvailable((pre) => (pre = !pre));
                                    }}
                                />
                            }
                            label="هل هذا المنتج متاح؟"
                        />
                    </FormGroup>
                </div>
                <div className="col-md-4 col-lg-4">
                    <FormGroup>
                        <FormControlLabel
                            control={
                                <Switch
                                    name="show_price"
                                    checked={show_price}
                                    color="warning"
                                    onChange={(e) => {
                                        setShowPrice((pre) => (pre = !pre));
                                    }}
                                />
                            }
                            label="هل يظهر سعر المنتج؟"
                        />
                    </FormGroup>
                </div>
                <div className="col-md-4 col-lg-4">
                    <FormGroup>
                        <FormControlLabel
                            control={
                                <Switch
                                    name="isNewCart"
                                    checked={isNewCart}
                                    color="warning"
                                    onChange={(e) => {
                                        setIsNewCart((pre) => (pre = !pre));
                                    }}
                                />
                            }
                            label="هل يستخدم نظام السلة الجديد؟"
                        />
                    </FormGroup>
                </div>
                <div>
                    <button
                        style={{ margin: "40px 0 0 10px", minWidth: "fit-content" }}
                        className="button"
                        onClick={() => {
                            setProductOptions((prevOptions) => [
                                ...prevOptions,
                                {
                                    id: prevOptions.length,
                                    name: "",
                                    options: [],
                                    type: "single",
                                    new: true,
                                },
                            ]);
                        }}
                        type="button"
                    >
                        إضافه خيار
                    </button>
                </div>
                {productOptions.map((item) => (
                    <OptionGroup
                        key={item.id}
                        index={item.id}
                        getOptionData={getOptionData}
                        group={item}
                        deleteGroup={deleteGroupHandler}
                        deleteOption={deleteOption}
                        options={options}
                    />
                ))}
                <div className="submit">
                    <button
                        style={{
                            marginTop: "20px",
                            width: "250px",
                            fontWeight: "bold",
                            float: "left",
                        }}
                        className="button"
                        type="submit"
                    >
                        حفظ التعديلات
                    </button>
                </div>
            </form>
        </div>
    );
};
export default EditProduct;
